import { useEffect } from 'react';
import { authFetch } from '../utils/api';

// Sends a heartbeat every 2 minutes to keep the user marked as online
export default function useHeartbeat() {
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const ping = () => {
      authFetch('/authentication/heartbeat/', { method: 'POST' }).catch(() => {});
    };

    // Ping immediately on mount
    ping();

    // Then every 2 minutes
    const interval = setInterval(ping, 2 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);
}
